module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_8003.d103716a.png";